<template>
	<div class="page " style="overflow-x: hidden;">

		<Header class="absolute z-1 top-0 left-0 right-0 text-white"></Header>

		<div class="relative">
			<slot></slot>
		</div>

		
	</div>
</template>

<script>
	import Header from './Header.vue';
	import Footer from './Footer.vue';
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			Header,
			Footer,
		},
		data() {
			return {

			}
		},
		methods: {
			publish() {

				request({
					url: '/api/house/updateActivityByMode',
					data: {
						mode: 'create'
					},
					success: resp => {
						this.$router.push('/activity_form?id=' + resp.data.houseActivity.id)
					}
				})



			},
		}
	}
</script>

<style scoped>


</style>